module.exports = __webpack_public_path__ + "img/section1_phone@3x.08efa3cf.png";